import React from "react";
import Button from "~/components-shared/Button";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import mixpanel from "mixpanel-browser";
import Modal from "~/components-shared/Modal";
import toastsActionCreators from "~/store/toasts/actions";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import styled from "styled-components";
import { StatusStateEnum } from "~/types/enums";
import { Alert } from "~/components-shared";
import shareInSlackSchema from "~/forms/ShareInSlackForm/shareInSlackSchema";
import ShareInSlackForm from "~/forms/ShareInSlackForm";
import insightsSelectors from "~/store/insights/selectors";
import insightsActionCreators from "~/store/insights/actions";
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;
`;
const InsightsShareInSlackModal = () => {
  const {
    t
  } = useTranslation();
  const filter = useSelector(insightsSelectors.getFilter);
  const status = useSelector(insightsSelectors.getShareStatus);
  const error = useSelector(insightsSelectors.getShareError);
  const dispatch = useDispatch();
  const defaultValues = {
    slackUserIds: [],
    slackChannelIds: []
  };
  const {
    handleSubmit,
    control,
    reset
  } = useForm({
    resolver: yupResolver(shareInSlackSchema),
    defaultValues
  });
  const onSubmit = handleSubmit(data => {
    dispatch(insightsActionCreators.shareSlackStarted({
      dateFrom: filter.dateFrom,
      dateTo: filter.dateTo,
      topicIds: filter.topicIds,
      ...data
    }, _ref => {
      let {
        data: response
      } = _ref;
      if (response === true) {
        dispatch(toastsActionCreators.pushed({
          severity: "success",
          message: t("InsightsShareInSlackModal.reportShared"),
          timeout: 10000
        }));
        reset(defaultValues);
      }
    }));
    mixpanel.track(`Insights Share in Slack – Share`, {
      ...data
    });
  });
  const onCancel = () => {
    dispatch(insightsActionCreators.actionChanged(null, null));
    mixpanel.track(`Insights Share in Slack – Cancel`);
  };
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("InsightsShareInSlackModal.shareInSlack"),
    onClose: onCancel,
    maxWidth: "540px",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(ShareInSlackForm, {
    control: control
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: onCancel,
    rounded: true
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    loading: status === StatusStateEnum.LOADING,
    onClick: onSubmit,
    s: {
      ml: 2
    },
    fullWidth: true,
    rounded: true
  }, t("common.actions.share")))));
};
export default InsightsShareInSlackModal;